var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDesktop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "desktop_svg__svg-safari-fix",
  viewBox: "0 0 24 24",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.48 3H5.52C3.58 3 2 4.58 2 6.52v7.39c0 1.94 1.58 3.52 3.52 3.52h3.96l-.39 1.56H7.36c-.55 0-1 .45-1 1s.45 1 1 1h9.28c.55 0 1-.45 1-1s-.45-1-1-1h-1.73l-.39-1.56h3.96c1.94 0 3.52-1.58 3.52-3.52V6.52C22 4.58 20.42 3 18.48 3m-5.63 16h-1.7l.39-1.56h.91l.39 1.56zM20 13.91c0 .84-.68 1.52-1.52 1.52H5.52c-.84 0-1.52-.68-1.52-1.52V6.52C4 5.68 4.68 5 5.52 5h12.95c.84 0 1.52.68 1.52 1.52v7.39z"
})));
export default SvgDesktop;